import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/divorces.actions';

import LayoutContainer from 'containers/LayoutContainer';
import DivorcesShow from 'views/public/DivorcesView/components/DivorcesShow';

import Loading from 'components/commons/Loading';

import 'views/public/DivorcesView/components/DivorcesShow/i18n';

const DivorcesShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.divorces);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <DivorcesShow item={item} />
      {loading && <Loading isModalMode message={i18next.t<string>('DIVORCES_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default DivorcesShowContainer;
